import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';
import vaflePNG from '../../../img/vaflePNG.png'

const Bubble = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Збери свою вафлю'/>
            <main className={s.main}>
                <div className={s.flex_box}>
                    <div>
                        <p>1. Смак вафлі</p>
                        <Product name='Ванiльний'/>
                        <Product name='Шоколадний'/>
                        <p>2. Випiчка</p>
                        <Product name='Бабл-вафля' price='35'/>
                        <Product name='Рiжок' price='35'/>
                        <p>3. Наповнювач</p>
                        <Product name='Вершки' price='25'/>
                        <Product name='Морозиво' price='25'/>
                        <Product name='Шоколадно-фундучна паста' price='30'/>
                        <p>5. Посипки</p>
                        <Product name='Мелений горiх' price='9'/>
                        <Product name='Маршмеллоу' price='9'/>
                        <Product name='Мармелад' price='9'/>
                        <Product name='Кондитерська вермишель' price='6'/>
                        <Product name='Повiтряний рис' price='9' info1='в молочному шоколадi'/>
                        <Product name='Шоколаднi краплi' price='9'/>
                        <Product name='Рiзнобарвне драже' price='9'/>
                        <Product name='Кондитерське сердечко' price='6'/>
                        <Product name='Кондитерська Нонпарель' price='6'/>
                    </div>
                    <div>
                        <img src={vaflePNG} alt="Вафля" />
                        <p>4. Фрукти</p>
                        <Product name='Банан' price='10'/>
                        <Product name='Кiвi' price='15'/>
                        <Product name='Яблуко' price='10'/>
                        <Product name='Персик' price='15'/>
                        <Product name='Ананас' price='15'/>
                        <p>6. Солодощi</p>
                        <Product name='Снiкерс' price='12'/>
                        <Product name='Твiкс' price='12'/>
                        <Product name='Орео' price='12'/>
                        <Product name='Баунтi' price='12'/>
                        <Product name='Топiнг' price='5'/>
                        <Product name='Вафельнi трубочки' price='12'/>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default Bubble;